import React,{useState,useEffect} from 'react'
import { Box, IconButton, Table, TableBody, Tooltip,
    TableContainer, TableHead, TableRow, Typography,    
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment';
import {celda} from '../Generales/TablaGeneral';
import { printConsole } from '../funciones/ConsolaLog';
import NuevoContrato from './NvoEditSeguro';
import {AddCircleOutline} from '@material-ui/icons';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
//import ArrowCircleDownIcon from '@material-ui/icons/ArrowCircleDown';
import ModalNvoEdit from './NvoEditRelMaquina';
import CreateIcon from '@material-ui/icons/Create';
import {findNumberCad} from '../funciones/FindNumber'
const useStyles = makeStyles((theme) => ({
    
        root: {
            width: '100%',
        },
        container: {
            maxHeight: 420,
            width: '100%',//'37rem',
        },
        tableRow: {
            "&$selected, &$selected:hover": {
                backgroundColor: "#F46239"
            }
        },
        tableCell: {
            "$selected &": {
                color: "white"
            }
        },
        hover: {},
        selected: {}
    
  }));

const TablaMaquinaria = ({datos,contrato,llenarListFile}) => {
    const classes = useStyles();
    const [selectedID, setSelectedID] = useState(null);
    const [modalNvoMaquina, setModalNvoMaquina]= useState(false);
    const cadena = localStorage.getItem("UserOperacion")+"|"; 
/*     useEffect(() => {
        printConsole(datos)
    
    
    }, [ ]) */
 
    function Row(props) {
        const {row} = props;       
   
        return (           
        <TableRow
            onClick={() => { setSelectedID(row) }}
            selected={selectedID?.Id === row.Id} className={classes.tableRow}
            classes={{hover: classes.hover, selected: classes.selected}}
        >
    
            
            {celda("center", {width: 45+'px',fontSize:12+'px'}, 
                row.FReg=== "1900-01-01 00:00" ? 
                "" : moment.utc( row.FReg).format('DD/MM/YYYY')
            , 3, classes.tableCell)}  
            {celda("left", {fontSize:12+'px'}, row.MaqNoEco, 2, classes.tableCell)}      
            {celda("left", {padingLeft:".2ren"}, `${row.MaqSerie}`, 4, classes.tableCell)}                                            
            {celda("left", {padingLeft:".2ren", fontSize:12+'px'}, row.MaqAlias, 5, classes.tableCell)}            
            {celda("left", {padingLeft:".2ren", fontSize:12+'px'}, row.TpNom, 5, classes.tableCell)}            
        </TableRow>                          
        );
    }

const tablaCompleta = () => {

    return (
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
        <TableHead>
            <TableRow>
                {findNumberCad('|41|',cadena) ?
                celda("left", {},  <span style={{display:"flex"}}>
                    <Tooltip title={`Editar Maquinarias de la Poliza ${contrato.Poliza}`} >
                        <IconButton onClick={()=>{setModalNvoMaquina(true)}} size="small" >
                            <CreateIcon />
                        </IconButton>
                    </Tooltip>
                    <Typography style={{marginRight:".5rem"}}>Fecha</Typography>
                    </span>
                , 1, "")
                :celda("center", {}, "",1, "")}                 
                {celda("center", {}, "NoEco",2, "")}  
                {celda("center", {}, "Serie",3, "")}                        
                {celda("center", {}, "Alias",4, "")}                    
                {celda("center", {}, "Tipo", 5, "")}                                                                                               
                
            </TableRow>
        </TableHead>
        <TableBody>                                                                 
        {datos.length !== 0 && datos[0].Id !== -1 && datos[0].Id !== "-1"? 
            (datos.map((row) => (
                <Row key={row.Id} row={row}/>
            ))) 
        : 
        <TableRow className={classes.tableRow} >            
            {celda("center", {}, "", 1, classes.tableCell)}               
            {celda("center", {}, "Sin", 2, classes.tableCell)}
            {celda("center", {}, "", 3, classes.tableCell)}
            {celda("center", {}, "Registros", 4, classes.tableCell)}
            {celda("center", {}, "", 5, classes.tableCell)}
        </TableRow>       
        }
        </TableBody>
    </Table>
    </TableContainer>
    )
    }

    const modNvoMaquina= modalNvoMaquina ? <ModalNvoEdit modalAbierto={modalNvoMaquina} funcionActuliza={llenarListFile}
                                            seguro={contrato}   listRelacionadas={datos} titulo={ `Asignación de Maquinarias de  la Poliza ${contrato.Poliza}`}
                                            setModalAbierto={setModalNvoMaquina} listMaquina={datos} /> :null
  return (
    <Box>
        {modNvoMaquina}
        <div><Typography color="primary" style={{fontSize:18,fontWeight:500}}>{`Maquinarias de la Poliza ${contrato.Poliza}`}</Typography></div>
        {tablaCompleta()}
   </Box>
  )
}

export default TablaMaquinaria